import type { OverlaySwitch } from "@helm/chart";

/**
 * Overlay switches (owner 2026-09-27, Glacis references), in menu order. The session and time
 * settings (B3) have their own section (`SessionOverlayMenu`).
 */
export const OVERLAY_ITEMS: { key: OverlaySwitch; label: string; hint: string }[] = [
  {
    key: "orderBar",
    label: "Order bar",
    hint: "Buy / Sell Mkt, Close, quantity, account and bracket above this chart",
  },
  {
    key: "trades",
    label: "Position & order lines",
    hint: "Position, order, TP and SL lines: drag to move, × to cancel, P&L if hit",
  },
  {
    key: "levels",
    label: "Key levels",
    hint: "Prior day, overnight, session, 4H and 15M highs / lows (intraday time charts)",
  },
  {
    key: "stats",
    label: "Stats box (ROC / ATR)",
    hint: "TODAY · FLIP · ATR% · DR · ATR · ON% · RSI 1h / 4h / D (intraday time charts)",
  },
  {
    key: "heatmap",
    label: "Liquidity heatmap",
    hint: "Resting book size per price behind the candles (10-level depth until MBO)",
  },
];
